export default "__VITE_ASSET__abIy0qsE__"